import type { NavigationLink } from "@components/header/types";
import Link from "@components/Link";
import { useMarket } from "@features/market/useMarket";
import { MobileMenuContext } from "@context/mobileMenuContext";
import { ChevronRight as ArrowRightIcon } from "lucide-react";
import { usePathname } from "next/navigation";
import { useContext } from "react";

import { cn } from "@/lib/utils";
import { useMenuStore } from "@/stores/menuStore";

type MobileMenuLinkProps = {
  link?: NavigationLink;
};

export default function MobileMenuLink({ link }: MobileMenuLinkProps) {
  const pathname = usePathname();
  const { siteLocale: locale } = useMarket();
  const { setNavigationTree, setNavigationDirection } =
    useContext(MobileMenuContext);
  const setMobileMenuOpen = useMenuStore((state) => state.setMobileMenuOpen);

  if (!link) return null;

  const isCurrentPage = pathname.endsWith(link?.slug || "");

  const buttonAndLinkClassName = cn(
    "flex w-full items-center justify-between px-4 py-2 text-left",
    isCurrentPage && "underline",
  );

  if (link.children?.length || link.highlight?.length)
    return (
      <div>
        <Link
          href={link.slug}
          locale={locale}
          className={buttonAndLinkClassName}
          onClick={(event) => {
            event.preventDefault();

            setNavigationTree((prev) => [...prev, link]);
            setNavigationDirection("right");
          }}
        >
          {link.title}
          <ArrowRightIcon strokeWidth={1} className="size-4" />
        </Link>
      </div>
    );

  return (
    <div>
      <Link
        href={link.slug}
        locale={locale}
        className={buttonAndLinkClassName}
        onClick={() => setMobileMenuOpen(false)}
      >
        {link.title}
      </Link>
    </div>
  );
}
